import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IController, IModule, IOnChangesObject, IQService, IScope} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {AktiverTotpDialog} from "../../modale/aktiverTotp/aktiverTotpDialog";
import _ from "lodash";
import {OtpOppsettRessurs} from "felles/tjenester/ressurser/OtpOppsettRessurs";
import {Autentisering} from "felles/tjenester/Autentisering";
import {WebNavigasjon} from "../../../../tjenester/WebNavigasjon";
import {AktiverEidDialogKontroller} from "../../modale/aktiverEid/aktiverEidDialog";
import {gettextCatalog} from "angular-gettext";
import {benyttetAutentiseringsmetodeSomStreng} from "felles/filter/benyttetAutentiseringsmetode";
import {CriiptoOIDCRessurs} from "../../../../../felles/tjenester/ressurser/CriiptoOIDCRessurs";
import {changesInneholder} from "../../../../../felles/stoettefunk/angularHjelpemetoder";
import {AktiverSmsOtpDialog} from "../../modale/aktiverSmsOtp/aktiverSmsOtpDialog";
import {Kontekst} from "../../../../../felles/tjenester/Kontekst";
import {ReautentiseringDialogKontroller} from "../../modale/reautentisering/reautentisering";


const css = require('./sikkerhetsinnstillinger.scss');

export class SikkerhetsinnstillingerKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
          .component('wmBrukerSikkerhetsinnstillinger', {
              bindings: {
                  bruker: "<"
              },
              controller: SikkerhetsinnstillingerKontroller.forInjisering(),
              template: require('./sikkerhetsinnstillinger.html')
          });
    }

    static forInjisering() {
        return [
            regNavn.ng.$scope,
            regNavn.ng.$q,
            regNavn.md.$mdDialog,
            OtpOppsettRessurs.regNavn,
            CriiptoOIDCRessurs.regNavn,
            AktiverTotpDialog.regNavn,
            Autentisering.regNavn,
            Kontekst.regNavn,
            WebNavigasjon.regNavn,
            regNavn.gettext.gettextCatalog,
            SikkerhetsinnstillingerKontroller
        ]
    }

    constructor(private $scope: IScope,
                private $q: IQService,
                private $mdDialog: angular.material.IDialogService,
                private totpOppsettRes: OtpOppsettRessurs,
                private criiptoOIDCRessurs: CriiptoOIDCRessurs,
                private aktiverTotpDialog: AktiverTotpDialog,
                private autentisering:Autentisering,
                private kontekst:Kontekst,
                private webNavigasjon:WebNavigasjon,
                private gettextCatalog:gettextCatalog) {
    }

    bruker: l.BrukerModell; //settes via bindings/$onChanges

    iEndrePassordmodus = false;

    tofaktorAutentiseringAktivert = false;
    totpOtpAutentiseringAktivert = false;
    smsOtpAutentiseringAktivert = false;
    reservekoderTotp:l.TotpReservekoderModell;
    reservekoderSmsOtp:l.SmsOtpReservekoderModell;
    eidAutentiseringAktivert = false;

    endrePassord() {
        this.iEndrePassordmodus = true;
    }

    loggUtAlleEnheter() {
        this.autentisering.loggUtAlleEnheter()
          .then(() => this.webNavigasjon.gåTilInnloggingssiden())
    }

    aktiverSmsOtp() {
        AktiverSmsOtpDialog.visAktiverSmsOtpDialog(this.$mdDialog)
          .then(() => this.relastBruker())
          .catch(_.noop);
    }

    deaktiverSmsOtp() {
        ReautentiseringDialogKontroller.visReautentiseringDialog(
            this.gettextCatalog.getString('Bekreft identiteten din for å deaktivere tofaktorinnlogging med SMS'),
            autentiseringsinfo => this.validerAutentiseringsinfoOgDeaktiverSms(autentiseringsinfo),
            this.$mdDialog);
    }

    visReserverkoderSmsOtp() {
        ReautentiseringDialogKontroller.visReautentiseringDialog(
            this.gettextCatalog.getString('Bekreft identiteten din for å vise reservekoder til tofaktorinnlogging med SMS'),
            autentiseringsinfo => this.validerAutentiseringsinfoOgVisReserverkoderSmsOtp(autentiseringsinfo),
            this.$mdDialog);
    }

    skjulReserverkoderSmsOtp(){
        this.reservekoderSmsOtp = null;
    }

    aktiverTotpOtp(){
        this.aktiverTotpDialog.visAktiverTotpDialog(()=>{
            this.relastBruker()
        });
    }

    deaktiverTotpOtp() {
        ReautentiseringDialogKontroller.visReautentiseringDialog(
            this.gettextCatalog.getString('Bekreft identiteten din for å deaktivere tofaktorinnlogging med kodegenerator'),
            autentiseringsinfo => this.validerAutentiseringsinfoOgDeaktiverTotpOtp(autentiseringsinfo),
            this.$mdDialog);
    }

    visReserverkoderTotp() {
        ReautentiseringDialogKontroller.visReautentiseringDialog(
            this.gettextCatalog.getString('Bekreft identiteten din for å vise reservekoder til tofaktorinnlogging med kodegenerator'),
            autentiseringsinfo => this.validerAutentiseringsinfoOgVisReserverkoderTotp(autentiseringsinfo),
            this.$mdDialog);
    }

    skjulReserverkoderTotp(){
        this.reservekoderTotp = null;
    }

    aktiverEid() {
        AktiverEidDialogKontroller.visAktiverEidDialog(this.$mdDialog)
          .then(() => this.relastBruker())
          .catch(_.noop);
    }

    deaktiverEid(metode: l.BenyttetAutentiseringsmetode) {
        ReautentiseringDialogKontroller.visReautentiseringDialog(
            this.gettextCatalog.getString('Bekreft identiteten din for å deaktivere innlogging med {{metode}}', {metode: benyttetAutentiseringsmetodeSomStreng(metode, this.gettextCatalog)}),
            autentiseringsinfo => this.validerAutentiseringsinfoOgDeaktiverEid(metode, autentiseringsinfo),
            this.$mdDialog);
    }

    $onChanges(changes: IOnChangesObject) {
        if (changesInneholder(changes, 'bruker'))
            this.initBruker(changes['bruker'].currentValue);
    }

    private relastBruker(){
        this.kontekst.relastBruker();
    }

    private initBruker(bruker:l.BrukerModell){
        this.bruker = bruker
        this.totpOtpAutentiseringAktivert = _(bruker.autentiseringsmetoder).includes(l.Autentiseringsmetode.totpOtp);
        this.smsOtpAutentiseringAktivert = _(bruker.autentiseringsmetoder).includes(l.Autentiseringsmetode.smsOtp);
        this.tofaktorAutentiseringAktivert = this.totpOtpAutentiseringAktivert || this.smsOtpAutentiseringAktivert;
        this.eidAutentiseringAktivert = !_.isEmpty(bruker.openIdAutentiseringsmetoder);
    }

    private validerAutentiseringsinfoOgDeaktiverEid(metode: l.BenyttetAutentiseringsmetode, autentiseringsinfo: l.Reautentiseringsinformasjon) {
        return this.criiptoOIDCRessurs.deaktiverOpenIdBinding({metode: metode, autentiseringsinfo: autentiseringsinfo}).$promise
            .then(respons => {
                if (respons.autentiseringOk)
                    this.relastBruker();
                return respons.autentiseringOk;
            });
    }

    private validerAutentiseringsinfoOgDeaktiverSms(autentiseringsinfo: l.Reautentiseringsinformasjon) {
        return this.totpOppsettRes.deaktiverSms(autentiseringsinfo).$promise
            .then(respons => {
                if (respons.autentiseringOk)
                    this.relastBruker();
                return respons.autentiseringOk;
            });
    }

    private validerAutentiseringsinfoOgVisReserverkoderSmsOtp(autentiseringsinfo: l.Reautentiseringsinformasjon) {
       return  this.totpOppsettRes.hentSmsOtpReservekoder(autentiseringsinfo).$promise
            .then(reservekoder => {
                if (reservekoder.autentiseringOk)
                    this.reservekoderSmsOtp = reservekoder;
                return reservekoder.autentiseringOk;
            });
    }

    private validerAutentiseringsinfoOgDeaktiverTotpOtp(autentiseringsinfo: l.Reautentiseringsinformasjon) {
        return this.totpOppsettRes.deaktiverTotp(autentiseringsinfo).$promise
            .then(respons => {
                if (respons.autentiseringOk)
                this.relastBruker();
                return respons.autentiseringOk;
            });
    }

    private validerAutentiseringsinfoOgVisReserverkoderTotp(autentiseringsinfo: l.Reautentiseringsinformasjon) {
        return this.totpOppsettRes.hentTotpReservekoder(autentiseringsinfo).$promise
            .then(reservekoder => {
                if (reservekoder.autentiseringOk)
                this.reservekoderTotp = reservekoder;
                return reservekoder.autentiseringOk;
            });
    }
}
